export const avatarColor = ["#18aed2","#cf7fd8","#77a577","#a58077","#e89cca","#6C7A02","#860cf3","#ec8da7","#13b9b2","#8668dc"];
